module.exports = __webpack_public_path__ + "static/cliff_back_albedo-8c4aca294ed4e3cdd7cc1c9499e92d6e.png";